/** API route map: URLS.Controller.PtoTimeoffSetup */
export const PtoTimeoffSetup = {
      Name: 'PtoTimeoffSetup/',
      GetAll: 'getall-ptotimeoff',
      Add: 'add-ptotimeoff',
      Update: 'update-ptotimeoff',
      Delete: 'delete-ptotimeoff',
      GetClientListByName: 'getClient-list-by-name-clientId',
      GetPtoClientListByNameId: 'getall-clientNameId',
};
